// extracted by mini-css-extract-plugin
module.exports = {"linksWrapper":"DashboardLinks_linksWrapper__QGlPz","dashboardLink":"DashboardLinks_dashboardLink__fuRb7","dashboardLinkIcon":"DashboardLinks_dashboardLinkIcon__VgZ6r"};